"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createSelectorsFactory = createSelectorsFactory;

var _reselect = require("reselect");

var _ramda = require("ramda");

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function createSelectorsFactory() {
  function getSelectors(getState) {
    var getIds = function getIds(state) {
      return state.ids;
    };

    var getEntities = function getEntities(state) {
      return state.entities;
    };

    var getAll = (0, _reselect.createSelector)(getIds, getEntities, function (ids, entities) {
      return ids.map(function (id) {
        return entities[id];
      });
    });

    var _getById = function getById(id) {
      return function (entities) {
        return entities[id];
      };
    };

    var getTotal = (0, _reselect.createSelector)(getIds, function (ids) {
      return ids.length;
    });

    if (!getState) {
      return {
        getIds: getIds,
        getEntities: getEntities,
        getAll: getAll,
        getTotal: getTotal,
        getById: function getById(id) {
          return (0, _reselect.createSelector)(getEntities, _getById(id));
        }
      };
    }

    var getGlobalizedEntities = (0, _reselect.createSelector)(getState, getEntities);
    return {
      getIds: (0, _reselect.createSelector)(getState, getIds),
      getEntities: getGlobalizedEntities,
      getAll: (0, _reselect.createSelector)(getState, getAll),
      getTotal: (0, _reselect.createSelector)(getState, getTotal),
      getById: function getById(id) {
        return (0, _reselect.createSelector)((0, _ramda.pipe)(getState, getEntities), _getById(id));
      }
    };
  }

  return {
    getSelectors: getSelectors
  };
}